$(document).ready(function(){
    
    $('.s1box_row').click(function(e) {
        $('.s1box_row').removeClass('active');
        $(this).addClass('active');	
    });
    
    $('.s1box_row_heading').click(function(e) {
            var thisDiv = $(this).next('.s1box_row_content');
            if ($(thisDiv).is(":visible")){
                $(this).next('.s1box_row_content').slideUp();
                $(this).removeClass('active');
            }else{
                $('.s1box_row_content').slideUp();
                $(this).next('.s1box_row_content').slideDown();
                $('.s1box_row_heading').removeClass('active');
                $(this).addClass('active');
            }
        });

    // $('.pck-opt').click(function(e) {
    //     $(this).closest('.package-box').find('.pck-opt').removeClass('active');
    //     $(this).addClass('active');	
    // });
    
    // $('.pck-opt').click(function(e) {
    //     if (!$(this).find(".pck-rad").attr("checked")) {
    //         $(this).parent('.package-box').find(".pck-rad").removeAttr("checked");
    //         $(this).find(".pck-rad").attr("checked", "checked");
    //     }
    // });
    // Delegate to a static parent like .package-box
    
    $('.package-box').on('click', '.pck-opt', function (e) {
        // Remove active class from all, add to clicked
        $(this).closest('.package-box').find('.pck-opt').removeClass('active');
        $(this).addClass('active');

        // Handle radio logic
        $(this).closest('.package-box').find(".pck-rad").prop("checked", false);
        $(this).find(".pck-rad").prop("checked", true).trigger('change'); // trigger 'change' to sync logic
    });

    
    // Guarded against double-init: on bogo, bogo_package_box1.liquid rebuilds
    // and re-initializes these same elements with the selected product's own
    // images. Whichever script runs first wins; re-running .slick() on an
    // already-initialized element throws and would otherwise abort the rest
    // of this ready callback (including the video carousel init below).
    if (!$('.package-div').hasClass('slick-initialized')) {
        $('.package-div').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            asNavFor: '.package-nav',
            autoplay: false,
            autoplaySpeed: 11000,
            dots: false,
        });
    }

    if (!$('.package-nav').hasClass('slick-initialized')) {
        $('.package-nav').slick({
            slidesToShow:5,
            slidesToScroll: 1,
            asNavFor: '.package-div',
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            arrows: false,
        });
    }
    
    $('.s6-vdo-row').slick({
        slidesToShow:4,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        autoplay: false,
        dots: true,
        variableWidth:true,
        centerMode: false,
        infinite:true,
        responsive: [
            {
                breakpoint: 1021,
                settings:{slidesToShow:3, slidesToScroll: 1, variableWidth:false,}
            },
            {
                breakpoint: 767,
                settings: {slidesToShow:3,centerMode: true, variableWidth:true, dots:false,}
                
            }
        ]
    });
    
    
    
    // Select all toggle elements and main item elements
    const toggles = document.querySelectorAll('.size-col');
    const mainItems = document.querySelectorAll('.select-size-field');
    
    // Add click event listeners to each toggle
        toggles.forEach(toggle => {
        toggle.addEventListener('click', (event) => {
            event.preventDefault(); // Prevent default link behavior
    
            // Get the data-comp attribute of the clicked toggle
            const targetComp = toggle.getAttribute('data-size');
    
            // Remove active class from all toggles and main items
            toggles.forEach(t => t.classList.remove('active'));
            // mainItems.forEach(item => item.classList.remove('active'));
    
            // Add active class to the clicked toggle
            toggle.classList.add('active');
    
            // Find and activate the corresponding main item
            // mainItems.forEach(item => {
            //     if (item.getAttribute('data-size') === targetComp) {
            //         item.classList.add('active');
            //     }
            // });
        });
    });
    
    
    
    //accordion JS 
    $(".acdn-heading").click(function() {
            
        var questionDiv = $(this);
        var answerDiv   = $(this).next('.acdn-content');
        var idx = $('.acdn-content').index(answerDiv);
        
        $('.acdn-content').each(function(index, ansDiv) {
            if(index != idx && $(ansDiv).is(':visible')) {
                $(ansDiv).slideUp(500, function() {
                    $(ansDiv).prev('.acdn-heading').removeClass('accordion-open');
                });
            }
        });
                    
        if (answerDiv.is(':visible')) {
            answerDiv.stop().slideUp(500, function() {
                questionDiv.removeClass('accordion-open');
            });
        } else {
        questionDiv.addClass('accordion-open');
        answerDiv.stop().slideDown(500);
        }
        
    });
    
    
    
    $(".btn_scorall").click(function() {
        $('html, body').animate({
            scrollTop: $("#select_pkg").offset().top - 50
        }, 2000);
    });
    
    $('ul.topMenu li a').click(function(event) {
        event.preventDefault();
        var ids = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(ids).offset().top - 50
        }, 2000);
    });
    
});

$(document).scroll(function() {
        
    if ($(this).scrollTop() > 110){
        $('.top-fix-bar').addClass('fixed-nav');
    }else{
        $('.top-fix-bar').removeClass('fixed-nav');
    }
    
    if ($(this).scrollTop() > 10){
    $('.mobilemenu').addClass('mobimenu-top');
    }else{
    $('.mobilemenu').removeClass('mobimenu-top');
    }
});


document.addEventListener("DOMContentLoaded", function () {
    let currentPlaying = null; // Track the currently playing video

    // Click on image or play button to play video
    document.addEventListener("click", function (event) {
        let imgBox = event.target.closest(".s6-vdo-col-img-box");

        if (imgBox) {
            let container = imgBox.closest(".s6-vdo-col");
            let video = container.querySelector("video");

            // If another video is playing, pause it
            if (currentPlaying && currentPlaying !== video) {
                currentPlaying.pause();
                let prevContainer = currentPlaying.closest(".s6-vdo-col");
                prevContainer.querySelector(".s6-vdo-col-img-box").style.display = "block";
                currentPlaying.style.display = "none";
            }

            // Hide image & play video
            imgBox.style.display = "none";
            video.style.display = "block";
            video.play();

            currentPlaying = video;
        }
    });


    // When the video ends, show the image again
    document.addEventListener("ended", function (event) {
        let video = event.target;
        let container = video.closest(".s6-vdo-col");
        let imgBox = container.querySelector(".s6-vdo-col-img-box");

        imgBox.style.display = "block";
        video.style.display = "none";
        video.currentTime = 0;
        video.pause();

        currentPlaying = null;
    }, true);
});